import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import HeroVideo from './HeroVideo';
import HeroSliderComponent from './HeroSliderComponent';

function HeroSlider({ content }) {
  return (
    <div>
      {
        get(content, 'video') &&
        <HeroVideo content={content} />
      }
      {
        !get(content, 'video') &&
        <HeroSliderComponent content={content} />
      }
    </div>
  );
}

HeroSlider.propTypes = {
  content: PropTypes.object.isRequired,
};

export default HeroSlider;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroSlider/index.js